<template>
    <div v-if="popupFestival">
        <div class="fadein">
            <div class="popup-image">
                <div class="guide-close-button floating-right">
                    <i class="fa fa-times-circle fa-2x" @click="closePopup"></i>
                </div>
                <div class="message">
                </div>
                <img :src="popupFestival.festival_popup.img" id="fadein1-img" style="cursor: pointer; height: 100%;">
            </div>
        </div>
    </div>
</template>
<script>
    import authCommon from '../mixins/authCommon'
    export default {
        mixins: [authCommon],
        mounted() {
            if(this.popupFestival) {
                this.popupBreath()
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/whg/vue/components/popup-festival.vue